import { ComponentProps, FunctionComponent, ReactNode } from 'react';
import { Badge } from 'softcat:components/badge.tsx';
import { Form } from 'softcat:components/form.tsx';

type FormStaticValueProperties = {
    label: ReactNode;
    status: ComponentProps<typeof Badge>['status'];
    values?: string[];
};

export const FormStaticBadges: FunctionComponent<FormStaticValueProperties> = ({ label, values = [], status }) => {
    return (
        <div className="sm:grid sm:grid-cols-4 sm:items-start sm:gap-4">
            <Form.Label>{label}</Form.Label>

            <div className="mt-2 flex gap-3 text-sm text-gray-400 sm:col-span-3 sm:mt-0 sm:pt-2">
                {values.length > 0
                    ? values.map((platform) => {
                          return (
                              <Badge key={platform} status={status}>
                                  {platform}
                              </Badge>
                          );
                      })
                    : '-'}
            </div>
        </div>
    );
};
